<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Anexos</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="finalizacao.anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        variant="success"
                                        @click.stop="inserirFinalizacaoAnexo()"
                                        v-if="mostrarBtnInserirAnexo"
                                        >Inserir Anexo</b-button
                                    >
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <app-finalizacao-anexo-download
                                    :finalizacaoAnexo="data"
                                    :finalizacoesServicos="finalizacoesServicos"
                                ></app-finalizacao-anexo-download>
                                <app-finalizacao-anexo-excluir
                                    :finalizacao="finalizacao"
                                    :finalizacaoAnexo="data"
                                    :finalizacoesServicos="finalizacoesServicos"
                                    @obterFinalizacaoAtualizada="
                                        obterFinalizacaoAtualizada()
                                    "
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirAnexo"
                                ></app-finalizacao-anexo-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <app-finalizacao-anexo-form
            ref="finalizacaoAnexoForm"
            @obterFinalizacaoAtualizada="obterFinalizacaoAtualizada()"
            :finalizacao="finalizacao"
            :finalizacoesServicos="finalizacoesServicos"
        ></app-finalizacao-anexo-form>
    </div>
</template>

<script>
import FinalizacaoAnexoDownload from './FinalizacaoAnexoDownload'
import FinalizacaoAnexoForm from './FinalizacaoAnexoForm'
import FinalizacaoAnexoExcluir from './FinalizacaoAnexosExcluir'

export default {
    props: {
        finalizacao: {
            type: Object,
            default: () => ({})
        },

        finalizacoesServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'anexoTipoDescr',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descritivo',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 0
        }
    },

    methods: {
        inserirFinalizacaoAnexo() {
            this.$refs.finalizacaoAnexoForm.mostrarModalFinalizacaoAnexoForm = true
        },

        obterFinalizacaoAtualizada() {
            this.$emit('obterFinalizacaoAtualizada')
        }
    },

    computed: {
        mostrarBtnInserirAnexo() {
            return (
                this.$temAcesso('CRED-FORN-FIN-03') &&
                (this.finalizacao.status === 0 || this.finalizacao.status === 5)
            )
        },

        mostrarBtnExcluirAnexo() {
            return (
                this.$temAcesso('CRED-FORN-FIN-03') &&
                (this.finalizacao.status === 0 || this.finalizacao.status === 5)
            )
        }
    },

    created() {},

    components: {
        AppFinalizacaoAnexoDownload: FinalizacaoAnexoDownload,
        AppFinalizacaoAnexoForm: FinalizacaoAnexoForm,
        AppFinalizacaoAnexoExcluir: FinalizacaoAnexoExcluir
    }
}
</script>
